//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Grid', component.exports)
}
export default {
	props: {
		gap: {
			type: String,
			default: '0'
		},
		width: {
			type: String
		},
		columns: {
			type: String
		},
		padX: {
			type: [String, Array],
			default: '0'
		},
		padY: {
			type: [String, Array],
			default: '0'
		}
	},
	// methods: {
	// 	widthToColumns(width) {
	// 		return Array.isArray(width)
	// 			? width.map(this.widthToColumns)
	// 			: !!width && `repeat(auto-fit, minmax(${this.width}, 1fr))`;
	// 	},
	// 	countToColumns(count) {
	// 		return Array.isArray(count)
	// 			? count.map(countToColumns)
	// 			: !!count && `repeat(${count}, 1fr)`;
	// 	}
	// },
	computed: {
		gridTemplateColumns() {
			if (this.width) {
				return `repeat(auto-fill, minmax(${this.width}, 1fr))`;
			} else {
				return `repeat(${this.columns}, 1fr)`;
			}
		}
	}
};
